import { api } from './api.js';
import type { AuthSuccess } from '../types/api.js';

export type InvitationInfo = {
  email: string;
  role: 'admin' | 'consultant';
  role_label: string;
  tenant_name: string;
  inviter_name: string;
  expires_at: string;
};

/** Public — fetch the invite behind a token. Throws ApiError on 404/410/409. */
export async function fetchInvitation(token: string): Promise<InvitationInfo> {
  return api<InvitationInfo>(`/auth/invitations/${encodeURIComponent(token)}`, {
    method: 'GET',
    noRetry: true,
  });
}

/** Public — accept the invite, creating the user and starting a session. */
export async function acceptInvitation(
  token: string,
  fullName: string,
  password: string,
): Promise<AuthSuccess> {
  return api<AuthSuccess>(`/auth/invitations/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
    body: { full_name: fullName, password },
    noRetry: true,
  });
}
